<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="位置" prop="type" >
        <a-select v-model="form.type" placeholder="请选择位置">
          <a-select-option :key="0">首页</a-select-option>
          <a-select-option :key="1">数码堂</a-select-option>
          <a-select-option :key="2">启动页</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title" >
        <a-input v-model="form.title" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="跳转类型" prop="linkType" >
        <a-select v-model="form.linkType" placeholder="请选择跳转类型">
          <a-select-option :key="0">不跳转</a-select-option>
          <a-select-option :key="3">外链</a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="跳转ID" prop="link" >
        <a-input v-model="form.link" placeholder="请输入跳转ID" />
      </a-form-model-item>-->
      <a-form-model-item label="外部链接地址" v-if="form.linkType == 3" prop="linkUrl" >
        <a-input v-model="form.linkUrl" placeholder="请输入外部链接地址" />
      </a-form-model-item>
      <a-form-model-item label="轮播图" prop="imgUrl" >
        <file-upload v-model="form.imgUrl" type="image" @change="changeSwiper"></file-upload>
      </a-form-model-item>

<!--      <a-form-model-item label="是否显示 1显示 0-不显示" prop="isVisible" >
      </a-form-model-item>-->
      <a-form-model-item label="排序" prop="sort" >
        <a-input-number v-model="form.sort" style="width: 100%;" :min="0" :step="1" placeholder="请输入排序" />
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBanner, addBanner, updateBanner } from '@/api/banner/banner'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: null,

        title: null,

        content: null,

        link: null,

        linkUrl: null,

        imgUrl: null,

        linkType: null,

        isVisible: 1,

        sort: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        imgUrl: [
          { required: true, message: '轮播图url不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    changeSwiper(e) {
      console.log(e);
      this.form.imgUrl = e;
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        title: null,
        content: null,
        link: null,
        linkUrl: null,
        imgUrl: null,
        linkType: null,
        isVisible: 1,
        sort: 0,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBanner({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBanner(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBanner(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
